import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";

/**
 * Intuit App Store "Get App Now" Post-Callback Completion Page.
 *
 * After the backend OAuth callback creates the user account on the fly and
 * connects the QuickBooks company, the browser is redirected here.
 * Per Intuit App Review requirement:
 *   "After this the user should be redirected within the application without
 *    being asked to log in again and the 'Disconnect' button should be displayed
 *    to the user inside the application."
 *
 * This page silently signs the user into Auth0 using the active Intuit session
 * (connection: "quickbooks-online") and lands them directly on /organizations.
 */
const IntuitConnectComplete = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (isLoading || hasStarted.current) return;
    hasStarted.current = true;

    if (isAuthenticated) {
      navigate("/organizations", { replace: true });
      return;
    }

    loginWithRedirect({
      authorizationParams: { connection: "quickbooks-online" },
      appState: { returnTo: "/organizations" },
    });
  }, [isLoading, isAuthenticated, loginWithRedirect, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <Spin size="large" />
    </div>
  );
};

export default IntuitConnectComplete;
